import { render, staticRenderFns } from "./addScheme.vue?vue&type=template&id=0b569bf0&scoped=true"
import script from "./addScheme.vue?vue&type=script&lang=js"
export * from "./addScheme.vue?vue&type=script&lang=js"
import style0 from "./addScheme.vue?vue&type=style&index=0&id=0b569bf0&prod&lang=stylus&scoped=true"
import style1 from "./addScheme.vue?vue&type=style&index=1&id=0b569bf0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b569bf0",
  null
  
)

export default component.exports